var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5853 10.3475L12.0611 1.77781L11.4898 1.20309C11.3596 1.07301 11.1835 1 11 1C10.8165 1 10.6405 1.07301 10.5103 1.20309L1.41483 10.3475C1.28143 10.4811 1.176 10.6403 1.10477 10.8156C1.03354 10.9909 0.997947 11.1788 1.00009 11.3682C1.00892 12.1493 1.65528 12.7728 2.43181 12.7728H3.36937V20H18.6307V12.7728H19.5881C19.9654 12.7728 20.3205 12.6241 20.5875 12.3556C20.7189 12.2239 20.823 12.0672 20.8938 11.8946C20.9647 11.7221 21.0007 11.5371 21 11.3504C21 10.9732 20.8522 10.616 20.5853 10.3475ZM12.2354 18.4023H9.76466V13.8756H12.2354V18.4023ZM17.0424 11.1751V18.4023H13.6473V13.3431C13.6473 12.8527 13.2524 12.4555 12.7649 12.4555H9.23521C8.74768 12.4555 8.3528 12.8527 8.3528 13.3431V18.4023H4.95771V11.1751H2.83992L11.0022 2.97161L11.5118 3.48419L19.1624 11.1751H17.0424Z",
    fill: "#435869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/icHome.0069e620536a4d91562c766d5a5c34c7.svg";
export { ForwardRef as ReactComponent };